import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';

import {DictModel} from '../../../dictionary/dict.model';
import {CreateDictionaryModel} from '../../../dictionary/create-dict.model';
import {DictEnum} from '../../../enums/dict.enum';

@Injectable()
export class DictService extends BaseHttpService {

  private static dictsLimit = 10;
  private static dictsPath = 'api/ecv/dicts/';
  private static createDictPath = DictService.dictsPath + 'create';
  public static getSkillsPath = DictService.dictsPath + 'competences';
  private static getDomainsPath = DictService.dictsPath + 'domains';
  private static getCvTargetsPath = DictService.dictsPath + 'cv_targets';

  private static domainDict: DictModel[];
  private static cvTargetDict: DictModel[];
  public domainDictEmitter = new EventEmitter<DictModel[]>();
  public cvTargetDictEmitter = new EventEmitter<DictModel[]>();

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  public getDictionary(id: number): Observable<any> {
    return this.httpGet(DictService.dictsPath + id);
  }

  public getDictContaining(dict: DictEnum, lang: string, searchQuery: string): Observable<any> {
    return this.httpGet(DictService.dictsPath + dict + '?lang=' + lang + '&limit=' + DictService.dictsLimit + '&search=' + encodeURIComponent(searchQuery));
  }

  public getDomains(): DictModel[] {
    if (!DictService.domainDict) {
      DictService.domainDict = [];
      this.httpGet(DictService.getDomainsPath).subscribe(response => {
        DictService.domainDict = <DictModel[]>response;
        this.domainDictEmitter.emit(DictService.domainDict);
      });
    }
    return DictService.domainDict;
  }

  public getPurposes(): DictModel[] {
    if (!DictService.cvTargetDict) {
      DictService.cvTargetDict = [];
      this.httpGet(DictService.getCvTargetsPath).subscribe(response => {
        DictService.cvTargetDict = <DictModel[]>response;
        this.cvTargetDictEmitter.emit(DictService.cvTargetDict);
      });
    }
    return DictService.cvTargetDict;
  }

  public createDict(model: CreateDictionaryModel) {
    return this.httpPost(DictService.createDictPath, model);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/dict.service.ts